import time from '../en/time'

const cnTime = {}

for (const cn in time) {
  cnTime[cn] = cn
}

export default cnTime
